import { render } from "./BusinessLookupComponent.vue?vue&type=template&id=a9685a1a&scoped=true"
import script from "./BusinessLookupComponent.vue?vue&type=script&lang=js"
export * from "./BusinessLookupComponent.vue?vue&type=script&lang=js"

import "./BusinessLookupComponent.vue?vue&type=style&index=0&id=a9685a1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9685a1a"]])

export default __exports__